import React, { useState } from "react";
import {
  TextField,
  Switch,
  Tooltip,
  FormControlLabel,
  Grid,
  InputAdornment,
  Typography,
} from "@material-ui/core";
import { useStyles } from "./ConvenienceFeeInput.style";
import QRCode from "react-qr-code";

const ConvenienceFeeInput = ({
  fieldError,
  existingFee,
  feeChanged,
  SaveEntitySetting,
  saveMobilePayMessage,
  noLPRMessage,
  noLPRMessageChanged,
  toggleEnable,
  enabledToggle,
  toggleCharge,
  chargeOnZeroToggle,
  mobilePayEnabled,
  toggleMobileFeeEnabled,
  entityID,
  settingValues,
}) => {
  const classes = useStyles();
  const [messageError, setMessageError] = useState(false);
  const location = window.location;
  const port = location.port ? `:${location.port}` : "";
  const baseUrl = `${location.protocol}//${location.hostname}${port}`;
  const mobilePayUrl = `${baseUrl}/mobilepay/lpr-find/${entityID}`;

  return (
    <> 
    <Grid container>     
        <Grid container spacing={3} xs={12} sm={4} md={4} lg={4} xl={4}>
          <Grid
            data-tag="mobilePaySwitch"
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
          >
            <FormControlLabel
              labelPlacement="end"
              data-id="enableMobilePaySwitch"
              data-testid="enableMobilePaySwitch"
              control={
                <Switch
                  checked={mobilePayEnabled}
                  data-checked={mobilePayEnabled}
                  onChange={toggleMobileFeeEnabled}
                  color="primary"
                />
              }
              label="Enable Mobile Pay"
            />
          </Grid>
          <Grid
            data-tag="conveneienceFee"
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
          >
            <FormControlLabel
              labelPlacement="end"
              disabled={!mobilePayEnabled}
              data-id="enableConvFeeSwitch"
              data-testid="enableConvFeeSwitch"
              control={
                <Switch
                  checked={enabledToggle}
                  data-checked={enabledToggle}
                  onChange={toggleEnable}
                  color="primary"
                />
              }
              label="Enable Convenience Fee"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={8} xl={12}>
            <TextField
              error={fieldError}
              helperText={fieldError && `Must be a valid number between 0 and 10000.`}
              variant="outlined"
              type="text"
              data-id="convFeeTextField"
              name={"convFeeTextField"}
              fullWidth
              value={existingFee}
              disabled={!mobilePayEnabled ? true : !enabledToggle}
              label="mobile pay convenience fee"
              onChange={(e) => feeChanged(e.target.value)}
              onBlur={(e) =>
                SaveEntitySetting({
                  name: "setting.conveniencefee",
                  value: e.target.value,
                })
              }
              InputProps={{
                inputProps: {
                  "data-testid": "convFeeTextField",
                  "aria-label": "convFeeTextField",
                },
                inputMode: "numeric",
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
            <Tooltip title="This allows a convenience fee to be charged on a $0.00 transaction">
              <FormControlLabel
                labelPlacement="end"
                disabled={!mobilePayEnabled ? true : !enabledToggle}
                style={{ marginLeft: ".5%", marginBottom: "2%" }}
                data-id="chargeOnZeroSwitch"
                data-testid="chargeOnZeroSwitch"
                control={
                  <Switch
                    checked={chargeOnZeroToggle}
                    data-checked={chargeOnZeroToggle}
                    onChange={toggleCharge}
                    size="small"
                    color="primary"
                  />
                }
                label="Charge On $0"
              />
            </Tooltip>
          </Grid>
          {(mobilePayEnabled && settingValues.lprTicketless === true) && (
            <Grid item xs={12}>
              <Tooltip title="Enter a message that will show to users when the search cannot find their license plate. 300 character limit.">
                <TextField
                  error={messageError}
                  helperText={messageError ? "Message must be 300 characters or less." : `${noLPRMessage?.length || 0}/300`}
                  variant="outlined"
                  type="text"
                  multiline
                  rows={3}
                  data-id="noLPRSeachResultField"
                  name={"noLPRSeachResultField"}
                  fullWidth
                  value={noLPRMessage}
                  label="No search results message"
                  onChange={(e) => {
                    noLPRMessageChanged(e.target.value);
                    setMessageError(e.target.value.length > 300);
                  }}
                  onBlur={(e) => {
                    if (e.target.value.length > 300) return;
                    saveMobilePayMessage(e.target.value);
                  }}
                  InputProps={{
                    inputProps: {
                      "data-testid": "noLPRSeachResultMessage",
                      "aria-label": "noLPRSeachResultMessage",
                    },
                  }}
                />
              </Tooltip>
            </Grid>
          )}
        </Grid>
        {(mobilePayEnabled && settingValues.lprTicketless === true) && (
          <Grid container spacing={3} xs={12} sm={8} md={8} lg={8} xl={8}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
            >
              <Typography
                variant="body2"
                className={classes.mobilePayUrl}
              >
                Ticketless Mobile Pay URL: {mobilePayUrl}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className={classes.mobilePayQRCode}
            >
              <QRCode
                value={`${mobilePayUrl}`}
                id="mobilePayQrCode"
                size={150}
                role="img"
                aria-label="Mobile Pay QR Code"
              />
            </Grid>
          </Grid>
        )} 
        </Grid>    
    </>
  );
};

ConvenienceFeeInput.defaultProps = {
  existingFee: 0.0,
  enabledToggle: false,
  chargeOnZeroToggle: false,
  mobilePayEnabled: false,
};

export default ConvenienceFeeInput;
